/**
 * Emotion styled 컴포넌트를 Tailwind className 문자열로 옮겼다.
 * IndustrialWaveformPlayer.tsx 가 `import * as S` 로 그대로 쓰고 있어 파일은 유지한다.
 *
 * theme`screens.sm` (480px) 미디어쿼리는 Tailwind 의 [@media(max-width:480px)]: 변형으로 옮겼다.
 */

export const playerContainer =
  'grid w-full grid-cols-[76px_minmax(0,1fr)] items-center gap-[16px] [@media(max-width:480px)]:grid-cols-[1fr] [@media(max-width:480px)]:gap-[12px]';

/*
 * transition 단축 속성 값에 쉼표가 있어 Tailwind arbitrary property 생성이 깨지고,
 * :active 의 transform 과 prefers-reduced-motion 해제까지 한 덩어리로 유지해야 해서
 * globals.css 의 .industrial-waveform-play-button 클래스로 남긴다.
 * (-webkit-tap-highlight-color 도 같은 클래스에 함께 둔다)
 */
export const playButton =
  'industrial-waveform-play-button inline-flex min-h-[44px] min-w-[88px] cursor-pointer touch-manipulation items-center justify-center rounded-[999px] border border-apps-brandGray50 bg-apps-coreGrayWhite text-[14px] font-bold leading-[140%] text-apps-coreGrayBlack focus-visible:shadow-[0_0_0_6px_rgba(255,61,89,0.16)] focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#ff3d59] disabled:cursor-not-allowed disabled:opacity-[0.48]';

/**
 * The waveform and the click marker share this cell so the marker can be
 * placed against the same box the bars are drawn across. The marker is a
 * sibling rather than a child: wavesurfer owns its container's contents.
 */
export const waveformCell = 'relative min-w-0';

export const waveformContainer =
  'min-h-[46px] min-w-0 touch-pan-y overflow-hidden';

/**
 * Anchored on the click's own x, running the height of the waveform. The
 * animated parts sit inside and are re-mounted per crossing, so the burst
 * is fired by the playhead rather than looping on a timer of its own.
 * globals.css 의 .industrial-click-marker 아래에 keyframes 와 함께 둔다.
 */
export const clickMarker =
  'industrial-click-marker pointer-events-none absolute inset-y-0 z-[2] grid place-items-center';

export const clickMarkerGuide = 'industrial-click-marker-guide';

export const clickMarkerFlash = 'industrial-click-marker-flash';

export const clickMarkerRing = 'industrial-click-marker-ring';

export const errorText =
  'col-[2/-1] text-[13px] font-semibold leading-[140%] text-apps-corePrimary01 [@media(max-width:480px)]:col-[1/-1]';
